/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { BadgeCheck, Radio } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j06-s03-ativar-comunicar';
export function AtivarComunicacaoOsPage() {
  const [s, setS] = useState<any>();
  const [erro, setErro] = useState('');
  async function call(path: string, body?: any) {
    try {
      const r = await chamarApi<any>(NS + path, {
        metodo: path === '/state' ? 'GET' : 'POST',
        corpo: body,
      });
      setS(r.state);
      setErro('');
    } catch {
      setErro('Não foi possível concluir a ativação.');
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando ordens validadas…
      </main>
    );
  return (
    <main className="min-w-0 max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <header>
        <h1 className="text-3xl font-semibold">{s.titulo}</h1>
        <p>{s.descricao}</p>
      </header>
      {(erro || s.alertas?.length > 0) && (
        <div role="alert" className="rounded-md border border-destructive p-3">
          {erro || s.alertas[0].mensagem}
        </div>
      )}
      <section aria-label="Ordens prontas para ativação" className="space-y-3">
        {s.ordens.length === 0 ? (
          <p className="rounded-md border p-5">Nenhuma OS validada para ativar.</p>
        ) : (
          s.ordens.map((o: any) => (
            <article key={o.id} className="rounded-md border p-4">
              <h2 className="font-semibold">
                <BadgeCheck className="mr-2 inline h-5 w-5" />
                OS #{o.numero} · revisão {o.revisao}
              </h2>
              <p>
                {o.inicio} a {o.fim} · {o.status} · validação {o.validacaoStatus ?? 'ausente'} ·
                reserva {o.reservaStatus ?? 'ausente'}
              </p>
              {o.ativacaoId && <p className="mt-2 break-all text-sm">Correlação: {o.ativacaoId}</p>}
              <Button
                className="mt-3"
                onClick={() =>
                  void call('/verbs/ativar_e_comunicar', {
                    ordemServicoId: o.id,
                    chaveIdempotencia: `j06-s03-ativar-${o.id}-r${o.revisao}`,
                  })
                }
              >
                <Radio className="mr-2 h-4 w-4" />
                {o.ativacaoId ? 'Repetir ativação' : 'Ativar e comunicar'}
              </Button>
            </article>
          ))
        )}
      </section>
    </main>
  );
}
